<script setup lang="ts">
</script>

<template>
  <div class="toast">
    <div class="icon">
      <icon-action type="offline" size="xs" />
    </div>
    <div>
      Attempting to reconnect...
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.toast
  @apply bg-[#{$toast-bg-default}] h-6 px-2.5 rounded-full
  @apply inline-flex items-center gap-1.5
  @apply t-menu-xs text-ellipses-inline
  @apply backdrop-blur-$menu-blur-default backdrop-filter

.icon
  @apply flex items-center justify-center
</style>
